import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "wrap" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "row tail" }
const _hoisted_6 = {
  key: 0,
  class: "info"
}
const _hoisted_7 = { class: "wrap" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "detail" }
const _hoisted_10 = { class: "address" }
const _hoisted_11 = { class: "number" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 1,
  class: "msg"
}
const _hoisted_14 = {
  key: 1,
  class: "empty"
}

import { reactive, ref, onMounted } from "vue"
import { orderQuery } from "@/utils/api"
import { toast } from "@/components/toast"
import Loading from '@/components/loading.vue'
import FloatNav from '@/components/floatnav.vue'
import { getUrlParam } from "@/utils/util"



interface QueryState {
    loading: boolean;
    show: boolean;
    text: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'auth',
  setup(__props) {

const form = reactive({
    id: '',
})

const state = reactive<QueryState>({
    loading: false,
    show: false,
    text: '',
})
const items = ref<OrderItem[]>([])
const submit = async () => {
    if (!form.id) {
        toast('身份证号不能为空')
        return
    }
    state.loading = true
    const rsp = await orderQuery(form.id)
    state.loading = false
    if (rsp.result == 0) {
        state.text = '没有发现您的订单记录'
        items.value = rsp.data.items
        state.show = rsp.data.items.length == 0
    } else {
        state.text = rsp.message
        state.show = true
        toast(rsp.message)
    }
}

const clickAuth = (item: OrderItem) => {
    if (item.url) {
        window.open(item.url, '_blank')
    }

}

onMounted(() => {
    const id = getUrlParam('uid')
    form.id = id
    if (id) {
        submit()
    }
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title" }, "请输入您的真实身份证信息进行查询", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "required" }, "*", -1)),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "label" }, "身份证号", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.id) = $event)),
              type: "text",
              class: "input",
              placeholder: "请输入你的身份证号"
            }, null, 512), [
              [_vModelText, form.id]
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: "btn",
          onClick: submit
        }, "查询认证信息")
      ])
    ]),
    (items.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title" }, "查询到的订单信息", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: index,
                onClick: ($event: any) => (clickAuth(item))
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, "购买号码: " + _toDisplayString(item.number), 1),
                  _createElementVNode("div", _hoisted_11, "下单时间: " + _toDisplayString(item.create_at), 1)
                ]),
                (item.url)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "msg",
                      onClick: ($event: any) => (clickAuth(item))
                    }, " 实名认证 ", 8, _hoisted_12))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(item.rsp_msg), 1))
              ], 8, _hoisted_8))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (state.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(state.text), 1))
      : _createCommentVNode("", true),
    (state.loading)
      ? (_openBlock(), _createBlock(Loading, { key: 2 }))
      : _createCommentVNode("", true),
    _createVNode(FloatNav, { auth: false })
  ]))
}
}

})